import React from 'react';
import PropTypes from 'prop-types';
import { Card as MuiCard, CardHeader, CardContent, Grid, Typography, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const currency = (val = 0) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(val);

export default function AbandonedCartsCard({ data = {} }) {
  const { total = 0, totalValue = 0, potential = 0 } = data;

  return (
    <MuiCard elevation={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        title="Carritos abandonados"
        action={
          <Button component={RouterLink} to="/carts" size="small">
            Ver todos
          </Button>
        }
        sx={{ pb: 0 }}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Grid container textAlign="center" spacing={1}>
          <Grid item xs={4}>
            <Typography variant="h5">{total}</Typography>
            <Typography variant="caption" color="text.secondary">
              Carritos
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h5">{currency(totalValue)}</Typography>
            <Typography variant="caption" color="text.secondary">
              Valor total
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h5" color="error.main">
              {currency(potential)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Oportunidad
            </Typography>
          </Grid>
        </Grid>

        <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 2 }}>
          <Button variant="outlined" size="small" startIcon={<i className="bi bi-envelope" />}
            component={RouterLink} to="/carts/reminders">
            Enviar recordatorio
          </Button>
          <Button variant="outlined" size="small" startIcon={<i className="bi bi-graph-up" />}
            component={RouterLink} to="/stats">
            Ver análisis
          </Button>
        </Stack>
      </CardContent>
    </MuiCard>
  );
}

AbandonedCartsCard.propTypes = {
  data: PropTypes.shape({
    total: PropTypes.number,
    totalValue: PropTypes.number,
    potential: PropTypes.number,
  }),
};
